import React, { useEffect, useState } from "react";
import api, { inr } from "@/lib/api";
import { Search } from "lucide-react";

export default function AdminCustomers() {
  const [list, setList] = useState([]);
  const [q, setQ] = useState("");
  useEffect(() => { const t = setTimeout(() => api.get(`/admin/customers${q?`?q=${q}`:""}`).then(r=>setList(r.data)), 200); return () => clearTimeout(t); }, [q]);
  return (
    <div>
      <h1 className="font-display text-3xl font-bold mb-4">Customers</h1>
      <div className="bg-slate-100 rounded-full px-4 h-11 flex items-center mb-4 max-w-md"><Search size={16}/><input data-testid="cust-search" value={q} onChange={e=>setQ(e.target.value)} placeholder="Search by name, email, mobile…" className="bg-transparent flex-1 px-3 outline-none text-sm"/></div>
      <div className="bg-white border border-slate-100 rounded-2xl overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 text-xs uppercase text-slate-500"><tr><th className="text-left p-3">Customer</th><th>Mobile</th><th>Orders</th><th>Total Spent</th><th>Joined</th></tr></thead>
          <tbody>{list.map(c=>(
            <tr key={c.user_id} className="border-t border-slate-100">
              <td className="p-3"><div className="font-medium">{c.name}</div><div className="text-xs text-slate-500">{c.email}</div></td>
              <td className="text-center">{c.mobile||"—"}</td>
              <td className="text-center font-semibold">{c.order_count}</td>
              <td className="text-center font-semibold">{inr(c.total_spent)}</td>
              <td className="text-center text-xs">{c.created_at?new Date(c.created_at).toLocaleDateString():"—"}</td>
            </tr>
          ))}</tbody>
        </table>
      </div>
    </div>
  );
}
